import ReadLocationClient from 'use-case/location/readLocationClient';
import ReadLocationCriteria from 'use-case/location/readLocationCriteria';
import { Result } from 'domain/types';
import Location from 'domain/entity/location';

export type ReadLocationResult = Result<Location>;
export type ReadLocation = (criteria: ReadLocationCriteria) => Promise<ReadLocationResult>;

export default (getLocationClient: ReadLocationClient): ReadLocation => (criteria: ReadLocationCriteria): Promise<ReadLocationResult> =>
    getLocationClient(criteria);
